module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contentsPage",
    attrs: {
      "id": "d7e15"
    }
  }, [_c('h3', {
    staticClass: "toc",
    attrs: {
      "id": "d7e16"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c1#c1"
    }
  }, [_vm._v("Premonitions of the "), _c('i', [_vm._v("Titanic's")]), _vm._v(" Doom")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c2#c2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talk of the Devil")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c3#c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Headless Lover")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c4#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phantoms, the Derelicts and the Haunted")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c5#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Carters and the Poltergeist")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c6#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Screaming Skulls and Other Oddities")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c7#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Stranger in the Fog")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c8#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ship and the Phantom Faces")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c9#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghosts on the Road")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phantom Train")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Return from Silence")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hell Hounds and Other Creatures")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pilot of the "), _c('i', [_vm._v("Pinta")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c14#c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Footplate Ghost")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c15#c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Terrifying Experience of Mr and Mrs Carrington")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c16#c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Holy Fathers")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c17#c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What the Rector Saw")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c18#c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Skull in the Box")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c19#c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Curse of Doris Cook")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/HARP_9780715337851_epub_c20#c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chairman")]), _vm._v(" "), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f381478","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HARP_9780715337851_epub_toc.vue
// module id = 63
// module chunks = 0